module.exports = __webpack_public_path__ + "static/lunchtype22-light-webfont-5e368b6de43dee11a787709a7daf24dc.eot";